module.exports = __webpack_public_path__ + "static/img/icon-arrow-left.201fa80.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon/icon-arrow-left.svg
// module id = THzl
// module chunks = 74